export default {
    methods: {
        initRequestParams: function (ctx) {
            var params = {
                format: "json",
                page_size: ctx.perPage,
                page: ctx.currentPage
            }

            if (ctx.sortBy) {
                var ordering = {
                    order_by: (ctx.sortDesc ? "-" : "") + ctx.sortBy
                }

                params = {...params, ...ordering}
            }

            if (ctx.filter) {
                params = {...params, ...{q: ctx.filter}}
            }

            return params
        }
    }
}